module.exports = __webpack_public_path__ + "img/logo_joinus001.3fd96400.png";